export enum ContainerDesktopHeight {
  tablet = 506,
  middleDesktop = 666,
  largeDesktop = 794,
}
